import * as travelDeskTypes from "../../types/admin/travelDeskTypes";

//Get All Travel Tickets
export const getAllTravelTicketsReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case travelDeskTypes.GET_ALL_TRAVEL_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case travelDeskTypes.GET_ALL_TRAVEL_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case travelDeskTypes.GET_ALL_TRAVEL_TICKETS_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//Create Travel Ticket
export const createTravelTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case travelDeskTypes.CREATE_TRAVEL_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case travelDeskTypes.CREATE_TRAVEL_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case travelDeskTypes.CREATE_TRAVEL_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//Update Travel Ticket
export const updateTravelTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case travelDeskTypes.UPDATE_TRAVEL_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case travelDeskTypes.UPDATE_TRAVEL_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case travelDeskTypes.UPDATE_TRAVEL_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//Archive Travel Ticket
export const archiveTravelTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case travelDeskTypes.ARCHIVE_TRAVEL_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case travelDeskTypes.ARCHIVE_TRAVEL_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case travelDeskTypes.ARCHIVE_TRAVEL_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

// Add Travel Comment
export const addTravelCommentReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case travelDeskTypes.ADD_TRAVEL_COMMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case travelDeskTypes.ADD_TRAVEL_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case travelDeskTypes.ADD_TRAVEL_COMMENT_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//getCommentForOneTravelTicket
export const getCommentForOneTravelTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case travelDeskTypes.GET_COMMENTS_FOR_ONE_TRAVEL_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case travelDeskTypes.GET_COMMENTS_FOR_ONE_TRAVEL_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case travelDeskTypes.GET_COMMENTS_FOR_ONE_TRAVEL_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//deletetravelComment
export const deleteTravelCommentReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case travelDeskTypes.DELETE_TRAVEL_COMMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case travelDeskTypes.DELETE_TRAVEL_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case travelDeskTypes.DELETE_TRAVEL_COMMENT_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};
